export default __webpack_public_path__ + "static/media/2D1A7138.12205413.jpg";